import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { investorReferralApi } from '@/api/investor';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { usePopups } from '@/hooks';

export const AddReferralModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { showErrorToast, showSuccessToast } = usePopups();
  const { investor } = useSelector((state) => state);

  const requestCode = async () => {
    try {
      await investorReferralApi.requestRefferalCode(investor.accountRole);
      showSuccessToast('Request is sent');

      onClose();
    } catch (e) {
      showErrorToast(e, true);
      console.error(e);
    }
  };

  return (
    <Modal open={open} onCancel={onClose} title={t('Add client')} footer={null}>
      {investor.referralCode && (
        <div>
          {t('Share this code with your client')}{' '}
          <Typography.Text copyable code>
            {investor.referralCode}
          </Typography.Text>
        </div>
      )}

      {!investor.referralCode && (
        <div>
          <Typography.Paragraph>{t("You don't have code yet")}</Typography.Paragraph>
          <Typography.Paragraph strong>{t('Request code')}</Typography.Paragraph>

          <Button onClick={requestCode} type={'primary'}>
            {t('Make request')}
          </Button>
        </div>
      )}
    </Modal>
  );
};
